module.exports = __webpack_public_path__ + "assets/img/btn-detail-d654b343.png";